/* eslint-disable react-hooks/exhaustive-deps */
"use client"

import { useEffect, useState } from "react"
import {
  Dialog,
  DialogContent,
  IconButton,
  Grid,
  Tabs,
  Tab,
  Button,
  Box,
  Typography,
  Checkbox,
  FormControlLabel,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@material-ui/core"
import { DataGrid } from "@material-ui/data-grid"
import GetAppIcon from "@material-ui/icons/GetApp"
import RefreshIcon from "@material-ui/icons/Refresh"
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore"
import NavigateNextIcon from "@material-ui/icons/NavigateNext"
import SearchIcon from "@material-ui/icons/Search"
import VisibilityIcon from "@material-ui/icons/Visibility"
import { makeStyles } from "@material-ui/core/styles"
import { Close } from "@material-ui/icons"
import { useSelector } from "react-redux"
import ExpandMoreIcon from "@material-ui/icons/ExpandMore"
import ChevronRightIcon from "@material-ui/icons/ChevronRight"
import { getBuyOrderApprovalsDetailsRequest, getBuyOrdeStoreRequest, getBuyOrdeToPayRequest } from "../../actions/logistic-indicators.action"

const useStyles = makeStyles((theme) => ({
  dialog: {
    "& .MuiDialog-paper": {
      maxWidth: "960px",
      width: "960px",
      height: "85vh",
      margin: theme.spacing(1),
    },
  },
  dialogHeader: {
    padding: "4px 8px 4px 12px",
    borderBottom: "1px solid #e0e0e0",
    backgroundColor: "#2196f3",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: "32px",
  },
  dialogContent: {
    padding: "6px 8px",
    display: "flex",
    flexDirection: "column",
    height: "calc(100% - 32px)",
    overflow: "hidden",
  },
  formSection: {
    marginBottom: theme.spacing(0.5),
  },
  readOnlyField: {
    position: "relative",
    marginBottom: '10px',
    paddingRight: '10px'
  },
  readOnlyLabel: {
    position: "absolute",
    top: "-7px",
    left: "8px",
    fontSize: "0.625rem",
    fontWeight: 600,
    color: "#555",
    // backgroundColor: "white",
    padding: "0 4px",
    zIndex: 1,
    lineHeight: 1,
  },
  readOnlyValue: {
    fontSize: "0.75rem",
    padding: "6px 8px",
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
    color: "#333",
    minHeight: "28px",
    display: "flex",
    alignItems: "center",
    border: "1px solid #ddd",
    lineHeight: 1.3,
    width: '100%'
  },
  actionButtons: {
    display: "flex",
    gap: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    alignItems: "center",
  },
  iconButton: {
    padding: "1px",
    backgroundColor: "#4caf50",
    color: "white",
    fontSize: "10px",

    "&:hover": {
      backgroundColor: "#45a049",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "10px",
    },
  },
  dataGridContainer: {
    flex: 1,
    minHeight: 0,
    "& .MuiDataGrid-root": {
      fontSize: "0.75rem",
      border: "1px solid #e0e0e0",
    },
    "& .MuiDataGrid-columnHeader": {
      backgroundColor: "#f5f5f5",
      fontSize: "0.688rem",
      fontWeight: 600,
      padding: "2px 4px",
    },
    "& .MuiDataGrid-cell": {
      padding: "2px 4px",
    },
  },
  tabs: {
    borderTop: "1px solid #e0e0e0",
    minHeight: "36px",
    marginBottom: theme.spacing(0.5),
    "& .MuiTab-root": {
      minHeight: 36,
      textTransform: "none",
      fontSize: "0.75rem",
      padding: "6px 10px",
    },
    "& .Mui-selected": {
      backgroundColor: "#2196f3",
      color: "white",
    },
  },
  summaryRow: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
    padding: theme.spacing(0.5),
    borderTop: "1px solid #e0e0e0",
    fontSize: "0.75rem",
    backgroundColor: "#f9f9f9",
  },
  summaryItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
  },
  splitView: {
    display: "flex",
    gap: theme.spacing(0.75),
    flex: 1,
    minHeight: 0,
  },
  splitPanel: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
  },
  searchBar: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    marginBottom: theme.spacing(0.25),
    padding: theme.spacing(0.5),
    backgroundColor: "#f5f5f5",
    borderRadius: "4px",
  },
  searchInput: {
    flex: 1,
    padding: "3px 6px",
    fontSize: "0.75rem",
    border: "1px solid #ddd",
    borderRadius: "3px",
    outline: "none",
    "&:focus": {
      borderColor: "#2196f3",
    },
  },
  statusBar: {
    display: "flex",
    justifyContent: "space-around",
    padding: theme.spacing(0.5),
    borderTop: "1px solid #e0e0e0",
    fontSize: "0.688rem",
    backgroundColor: "#f9f9f9",
  },
  tabContent: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    overflow: "hidden",
  },
  closeButton: {
    padding: "2px",
    "& .MuiSvgIcon-root": {
      fontSize: "1.125rem",
      color: "black",
    },
  },
  dataGrid: {
    '& .MuiDataGrid-footerContainer': {
      minHeight: '35px',
    },
    '& .MuiTablePagination-toolbar': {
      minHeight: '35px',
      padding: '0 8px',
    },
    '& .MuiTablePagination-actions': {
      '& .MuiIconButton-root': {
        padding: '3px',
        height: '20px',
        width: '20px',
        '& .MuiSvgIcon-root': {
          color: '#000000', // Color negro para los iconos
          fontSize: '16px',
        },
        '&.Mui-disabled .MuiSvgIcon-root': {
          color: 'rgba(0, 0, 0, 0.26)', // Color para botones deshabilitados
        },
      }
    },
    '& .MuiTablePagination-select': {
      height: '20px',
      color: 'black',
    },
    '& .MuiTablePagination-caption': {
      color: 'black',
      margin: 0,
    },
    '& .MuiTablePagination-selectLabel': {
      color: 'black',
      margin: 0,
    }
  }

}))


const organizeHierarchicalData = (data) => {
  const byCentroCompra = {};
  
  data.forEach(item => {
    const centroCompraKey = item.CentroCompra;
    
    if (!byCentroCompra[centroCompraKey]) {
      byCentroCompra[centroCompraKey] = {
        centroCompra: item.CentroCompra,
        proyectos: {}
      };
    }

    const proyectoKey = item.CodProyecto;
    
    if (!byCentroCompra[centroCompraKey].proyectos[proyectoKey]) {
      byCentroCompra[centroCompraKey].proyectos[proyectoKey] = {
        proyecto: item.Proyecto,
        codProyecto: item.CodProyecto,
        pedidos: {}
      };
    }
    
    const pedidoKey = item.CodPedido;
    
    if (!byCentroCompra[centroCompraKey].proyectos[proyectoKey].pedidos[pedidoKey]) {
      byCentroCompra[centroCompraKey].proyectos[proyectoKey].pedidos[pedidoKey] = {
        pedido: item.CodPedido,
        nroPedido: item.NroPedido,
        items: []
      };
    }
    
    byCentroCompra[centroCompraKey].proyectos[proyectoKey].pedidos[pedidoKey].items.push({
      ...item,
      id: item.NroOCDP,
      type: "item",
      descripcion: item.Insumo,
      unidad: item.Unidad,
      cantidad: item.Cantidad,
      cOrigen: item.CantidadOrigen || "",
      highlight: false // Puedes modificar esta lógica según necesites
    });
  });
  
  const hierarchicalData = [];
  let centroCompraCount = 1;
  let proyectoCount = 1;
  let pedidoCount = 1;
  
  Object.keys(byCentroCompra).forEach(centroCompraKey => {
    const centroCompraData = byCentroCompra[centroCompraKey];
    const centroCompraNode = {
      id: `cc${centroCompraCount}`,
      type: "centralCompra",
      label: `Central Compra: ${centroCompraData.centroCompra}`,
      children: []
    };
    
    Object.keys(centroCompraData.proyectos).forEach(proyectoKey => {
      const proyectoData = centroCompraData.proyectos[proyectoKey];
      const proyectoNode = {
        id: `p${proyectoCount}`,
        type: "proyecto",
        label: `Proyecto: ${proyectoData.proyecto}`,
        children: []
      };
      
      Object.keys(proyectoData.pedidos).forEach(pedidoKey => {
        const pedidoData = proyectoData.pedidos[pedidoKey];
        const pedidoNode = {
          id: `ped${pedidoCount}`,
          type: "pedido",
          label: `Pedido: ${pedidoData.pedido}`,
          children: pedidoData.items
        };
        
        proyectoNode.children.push(pedidoNode);
        pedidoCount++;
      });
      
      centroCompraNode.children.push(proyectoNode);
      proyectoCount++;
    });
    
    hierarchicalData.push(centroCompraNode);
    centroCompraCount++;
  });
  
  return hierarchicalData;
};

const ReadOnlyField = ({ label, value, classes }) => (
  <Box className={classes.readOnlyField}>
    <Typography className={classes.readOnlyLabel}>{label}</Typography>
    <Box className={classes.readOnlyValue}>{value || "-"}</Box>
  </Box>
)

export default function BuyOrderModal({ open, onClose, title, paramBuyOrderData }) {
  const {buyOrderData, buyOrderAccumulated, buyOrderAccumulatedTotal, buyOrderDetailOrder, buyOrderApprovalData, buyOrderStoreData, buyOrderToPayData} = useSelector((state) => state.logisticIndicators);
  const classes = useStyles()
  const [activeTab, setActiveTab] = useState(0)
  const [expandedNodes, setExpandedNodes] = useState({
    cc1: true,
    p1: true,
    ped1: true,
  })

  useEffect(() => {
    if (activeTab === 3 && buyOrderApprovalData.length === 0) {
      getBuyOrderApprovalsDetailsRequest(paramBuyOrderData.NroOrden)
    }
    if (activeTab === 4 && buyOrderStoreData.length === 0) {
      getBuyOrdeStoreRequest(paramBuyOrderData.NroOrden)
    }
    if (activeTab === 5 && buyOrderToPayData.length === 0) {
      getBuyOrdeToPayRequest(paramBuyOrderData.NroOrden)
    }
  }, [activeTab])

  const toggleNode = (nodeId) => {
    setExpandedNodes((prev) => ({
      ...prev,
      [nodeId]: !prev[nodeId],
    }))
  }

  const accumulatedColumns = [
    { field: "Linea", headerName: "Linea"},
    { field: "CodInsumo", headerName: "Codigo", width: 140 },
    { field: "Insumo", headerName: "Recurso", flex: 1, minWidth: 300 },
    { field: "Unidad", headerName: "Unidad" },
    { field: "Cantidad", headerName: "Cantidad", width: 100, type: "number" },
    { field: "Precio", headerName: "Precio", width: 100, type: "number" },
    { field: "PrecioNeto", headerName: "Precio Neto", width: 110, type: "number" },
    { field: "Redondeo", headerName: "Redondeo", width: 100, type: "number" },
    {
      field: "afecto",
      headerName: "Afecto",
      width: 80,
      renderCell: (params) => (params.value ? "✓" : ""),
    },
    { field: "IGV", headerName: "Precio Con IGV", width: 130, type: "number" },
  ]

  const detalladoColumns = [
    { field: "descripcion", headerName: "Descripcion", flex: 1, minWidth: 250 },
    { field: "unidad", headerName: "Und.", width: 90 },
    { field: "cantidad", headerName: "Cantidad", width: 100, type: "number" },
  ]

  const inStoreColumns = [
    { field: "CodInsumo", headerName: "Codigo", width: 130 },
    { field: "Insumo", headerName: "Recurso", flex: 1, minWidth: 250 },
    { field: "Unidad", headerName: "Unidad", width: 90 },
    { field: "Cantidad", headerName: "Cant. Total", width: 110, type: "number" },
    { field: "CantidadEnAlmacen", headerName: "Cant. Almacen", width: 130, type: "number" },
    { field: "CantidadPorEntregar", headerName: "Cant. Pendien.", width: 130, type: "number" },
    { field: "PrecioNeto", headerName: "Precio Neto", width: 120, type: "number" },
    { field: "PrecioConIgv", headerName: "Precio IGV", width: 120, type: "number" },
    { field: "ParcialNeto", headerName: "Parcial Neto", width: 120, type: "number" },
  ]

  const approvalsColumns = [
    { field: "Orden", headerName: "Orden", width: 80 },
    { field: "Usuario", headerName: "Usuario", width: 100 },
    { field: "NombreUsuario", headerName: "Nombre Usuario", width: 180 },
    // { field: "obligat", headerName: "Obligat.", width: 90 },
    { field: "EMail", headerName: "Correo Electronico", flex: 1, minWidth: 180 },
    {
      field: "VistoBueno",
      headerName: "VB",
      width: 70,
      renderCell: (params) => (params.value ? "✓" : ""),
    },
    { field: "VistoBuenoFecha", headerName: "FechVB", width: 110 },
    { field: "Observaciones", headerName: "Observ.", width: 130 },
    // { field: "fecha", headerName: "Fecha", width: 110 },
    { field: "NoNotificar", headerName: "No Notificar", width: 110 },
    { field: "Jerarquia", headerName: "Jerarquia", width: 100 },
  ]

  const toPayColumns = [
    { field: "TipoDocumento", headerName: "Tipo de Documento", width: 160 },
    { field: "NroD", headerName: "N. Documento", width: 140 },
    { field: "FechaDocumento", headerName: "Fecha Docum.", width: 130 },
    { field: "TotalNeto", headerName: "Monto Neto", width: 120, type: "number" },
    { field: "MontoProgramado", headerName: "Monto Progr.", width: 130, type: "number" },
    { field: "MontoPagado", headerName: "Monto Pagado", width: 130, type: "number" },
    { field: "Saldo", headerName: "Saldo", width: 110, type: "number" },
    { field: "Estado", headerName: "Estado", width: 110 },
  ]

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue)
  }
  
  const renderHierarchicalRows = (node, level = 1) => {
    const isExpanded = expandedNodes[node.id]
    const rows = []

    if (node.type === "centralCompra" || node.type === "proyecto" || node.type === "pedido") {
        const levelClass =
            level === 1 ? classes.hierarchyLevel1 : 
            level === 2 ? classes.hierarchyLevel2 : 
            classes.hierarchyLevel3

        rows.push(
            <TableRow key={node.id} className={levelClass} onClick={() => toggleNode(node.id)}>
                <TableCell colSpan={4} style={{ paddingLeft: `${(level - 1) * 20}px` }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        {isExpanded ? (
                            <ExpandMoreIcon className={classes.expandIcon} />
                        ) : (
                            <ChevronRightIcon className={classes.expandIcon} />
                        )}
                        <span style={{ marginLeft: '8px' }}>{node.label}</span>
                    </div>
                </TableCell>
            </TableRow>,
        )

        if (isExpanded && node.children) {
            node.children.forEach((child) => {
                rows.push(...renderHierarchicalRows(child, level + 1))
            })
        }
    } else if (node.type === "item") {
        rows.push(
            <TableRow key={node.id} className={node.highlight ? classes.itemRowHighlight : classes.itemRow}>
                <TableCell style={{ paddingLeft: `${(level - 1) * 20 + 32}px` }}>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <Checkbox size="small" style={{ padding: "2px", marginRight: '8px' }} />
                        {node.descripcion}
                    </div>
                </TableCell>
                <TableCell align="center">{node.unidad}</TableCell>
                <TableCell align="right">{node.cantidad}</TableCell>
                <TableCell align="center">{node.cOrigen || ''}</TableCell>
            </TableRow>,
        )
    }

    return rows
  }


  const renderTabContent = () => {
    switch (activeTab) {
      case 0: // Detallado
        return (
          <>
            <Box className={classes.splitView}>
              <Box className={classes.splitPanel}>
                <Box className={classes.searchBar}>
                  <IconButton style={{height: '10px'}} size="small" className={classes.iconButton}>
                    <RefreshIcon />
                  </IconButton>
                  <input type="text" placeholder="Buscar..." className={classes.searchInput} />
                  <Typography variant="body2" style={{ fontSize: "0.75rem", whiteSpace: "nowrap" }}>
                    Pendientes 0 regs
                  </Typography>
                  <IconButton style={{height: '10px'}} size="small">
                    <NavigateBeforeIcon fontSize="small" />
                  </IconButton>
                  <IconButton style={{height: '10px'}} size="small">
                    <NavigateNextIcon fontSize="small" />
                  </IconButton>
                </Box>
                <Box className={classes.dataGridContainer}>
                  <DataGrid
                    rows={[]}
                    columns={detalladoColumns}
                    pageSize={10}
                    rowsPerPageOptions={[10]}
                    checkboxSelection
                    disableSelectionOnClick
                    density="compact"
                  />
                </Box>
              </Box>
              <Box className={classes.splitPanel}>
                <Box className={classes.searchBar}>
                  <SearchIcon fontSize="small" />
                  <input type="text" placeholder="Buscar" className={classes.searchInput} />
                  {/* <Typography variant="body2" style={{ fontSize: "0.75rem" }}>
                    0 regs
                  </Typography> */}
                </Box>
                <TableContainer component={Paper} style={{ flex: 1, overflow: "auto", border: "1px solid #e0e0e0" }}>
                  <Table size="small" className={classes.hierarchicalTable} stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>Descripcion</TableCell>
                        <TableCell align="center" style={{ width: "90px" }}>
                          Unid.
                        </TableCell>
                        <TableCell align="right" style={{ width: "100px" }}>
                          Cantidad
                        </TableCell>
                        <TableCell align="center" style={{ width: "100px" }}>
                          C.Origen
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {buyOrderDetailOrder.length > 0 && 
                      <TableBody>
                        {organizeHierarchicalData(buyOrderDetailOrder).map( item => (renderHierarchicalRows(item)))}
                      </TableBody>
                    }
                  </Table>
                </TableContainer>
              </Box>
            </Box>
            <Box className={classes.statusBar}>
              <Typography>
                <strong>Cantidad:</strong> 0
              </Typography>
              <Typography>
                <strong>Por Comprar:</strong> 0
              </Typography>
              <Typography>
                <strong>En Cotizacion:</strong> 0
              </Typography>
              <Typography>
                <strong>En Orden:</strong> 0
              </Typography>
              <Typography>
                <strong>En Almacen:</strong> 0
              </Typography>
              <Typography>
                <strong>Por Recibir:</strong> 0
              </Typography>
              <Typography>
                <strong>Por Atender:</strong> 0
              </Typography>
            </Box>
          </>
        )

      case 1: // Acumulado
        return (
          <>
            <Box className={classes.actionButtons}>
              <IconButton style={{height: '10px'}} size="small" className={classes.iconButton}>
                <GetAppIcon />
              </IconButton>
              <IconButton style={{height: '10px'}} size="small" className={classes.iconButton}>
                <RefreshIcon />
              </IconButton>
            </Box>
            <Box className={classes.dataGridContainer}>
              <DataGrid
                rows={buyOrderAccumulated}
                columns={accumulatedColumns}
                pageSize={100}
                rowsPerPageOptions={[100]}
                disableSelectionOnClick
                density="compact"
                pagination
                className={classes.dataGrid}
              />
            </Box>
            <Box className={classes.summaryRow}>
              <Box className={classes.summaryItem}>
                <Typography variant="caption" color="textSecondary">
                  Total Neto
                </Typography>
                <Typography variant="body2">
                  <strong>{buyOrderAccumulatedTotal?.split("|")[0] || ''}</strong>
                </Typography>
              </Box>
              <Box className={classes.summaryItem}>
                <Typography variant="caption" color="textSecondary">
                  Valor I.G.V
                </Typography>
                <Typography variant="body2">
                  <strong>{buyOrderAccumulatedTotal?.split("|")[1] || ''}</strong>
                </Typography>
              </Box>
              <Box className={classes.summaryItem}>
                <Typography variant="caption" color="textSecondary">
                  Percepcion
                </Typography>
                <Typography variant="body2">
                  <strong>{buyOrderAccumulatedTotal?.split("|")[2] || ''}</strong>
                </Typography>
              </Box>
              <Box className={classes.summaryItem}>
                <Typography variant="caption" color="textSecondary">
                  Redondeo
                </Typography>
                <Typography variant="body2">
                  <strong>{buyOrderAccumulatedTotal?.split("|")[3] || ''}</strong>
                </Typography>
              </Box>
              <Box className={classes.summaryItem}>
                <Typography variant="caption" color="textSecondary">
                  Total
                </Typography>
                <Typography variant="body2">
                  <strong>{buyOrderAccumulatedTotal?.split("|")[4] || ''}</strong>
                </Typography>
              </Box>
            </Box>
          </>
        )

      case 2: // Datos Adicionales
        return (
          <Box style={{ padding: "12px", overflowY: "auto", flex: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <ReadOnlyField label="Gestor de compra" value={buyOrderData?.GestorCompra} classes={classes} />
              </Grid>
              <Grid item xs={3}>
                <ReadOnlyField label="Lugar De Entrega" value={buyOrderData?.LugarDeEntrega} classes={classes} />
              </Grid>
              <Grid item xs={3} />

              <Grid item xs={6}>
                <ReadOnlyField label="Facturar a" value={buyOrderData?.IdentificadorFactura} classes={classes} />
              </Grid>
              <Grid item xs={6}>
                <ReadOnlyField label="Observación" value={buyOrderData?.Observacion} classes={classes} />
              </Grid>

              <Grid item xs={3}>
                <ReadOnlyField label="Tipo De Cambio" value={buyOrderData?.TipoDeCambio} classes={classes} />
              </Grid>


              <Grid container>
                <Grid item xs={6}>
                  <FormControlLabel
                    control={<Checkbox checked={buyOrderData?.TipoCambioNoOficial ? true : false} color="secondary" size="small" style={{top: '-12px'}} />}
                    label={<Typography style={{ fontSize: "0.813rem" }}>Tipo de Cambioo no Oficial</Typography>}
                    labelPlacement="start"
                  />
                </Grid>

                <Grid item xs={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<VisibilityIcon />}
                    size="small"
                    style={{ textTransform: "none" }}
                  >
                    Ver Notas
                  </Button>
                </Grid>

              </Grid>

              <Grid item xs={6}>
                <ReadOnlyField 
                  label="Registrado Por"
                  value={`${buyOrderData?.ActualizacionUsuario} ${buyOrderData?.ActualizacionFecha}`} 
                  classes={classes}
                />
              </Grid>
              <Grid item xs={6} />

              <Grid item xs={6}>
                <ReadOnlyField 
                  label="Modificado Por" 
                  value={`${buyOrderData?.ActualizacionUsuario} ${buyOrderData?.ActualizacionFecha}`} 
                  classes={classes}
                />
              </Grid>
              <Grid item xs={6} />

              <Grid item xs={6}>
                <ReadOnlyField label="Estado" value={buyOrderData?.Estado} classes={classes} />
              </Grid>
            </Grid>
          </Box>
        )

      case 3: // Aprobación
        return (
          <>
            <Box className={classes.actionButtons}>
              <IconButton style={{height: '10px'}} size="small" className={classes.iconButton}>
                <GetAppIcon />
              </IconButton>
              <IconButton style={{height: '10px'}} size="small" className={classes.iconButton}>
                <RefreshIcon />
              </IconButton>
              <Typography variant="body2" style={{ marginLeft: "auto", fontSize: "0.813rem" }}>
                0 regs
              </Typography>
            </Box>
            <Box className={classes.dataGridContainer}>
              <DataGrid
                rows={buyOrderApprovalData}
                columns={approvalsColumns}
                pageSize={10}
                rowsPerPageOptions={[10]}
                checkboxSelection
                disableSelectionOnClick
                density="compact"
              />
            </Box>
          </>
        )

      case 4: // En Almacen
        return (
          <>
            <Box className={classes.actionButtons}>
              <IconButton style={{height: '10px'}} size="small" className={classes.iconButton}>
                <GetAppIcon />
              </IconButton>
              <IconButton style={{height: '10px'}} size="small" className={classes.iconButton}>
                <RefreshIcon />
              </IconButton>
            </Box>
            <Box className={classes.dataGridContainer}>
              <DataGrid
                rows={buyOrderStoreData}
                columns={inStoreColumns}
                pageSize={100}
                rowsPerPageOptions={[100]}
                checkboxSelection
                disableSelectionOnClick
                density="compact"
              />
            </Box>
          </>
        )

      case 5: // Doc. por Pagar
        return (
          <>
            <Box className={classes.actionButtons}>
              <IconButton style={{height: '10px'}} size="small" className={classes.iconButton}>
                <GetAppIcon />
              </IconButton>
              <IconButton style={{height: '10px'}} size="small" className={classes.iconButton}>
                <RefreshIcon />
              </IconButton>
              <Typography variant="body2" style={{ marginLeft: "auto", fontSize: "0.813rem" }}>
                0 regs
              </Typography>
            </Box>
            <Box className={classes.dataGridContainer}>
              <DataGrid
                rows={buyOrderToPayData}
                columns={toPayColumns}
                pageSize={100}
                rowsPerPageOptions={[100]}
                checkboxSelection
                disableSelectionOnClick
                density="compact"
              />
            </Box>
          </>
        )

      default:
        return null
    }
  }

  return (
    <Dialog open={open} onClose={onClose} className={classes.dialog} maxWidth="md">
      <Grid 
        container 
        alignItems='center'
        justifyContent="space-between" 
        style={{height: '40px'}}
      >
        <Typography style={{ fontSize: "1rem", fontWeight: 600, color: "black", margin: '5px 0 0 10px' }}>{title}</Typography>
        <IconButton style={{height: '10px', marginRight: '10px'}} onClick={onClose} className={classes.closeButton} >
          <Close />
        </IconButton>
      </Grid>

      <DialogContent className={classes.dialogContent}>
        <Box className={classes.formSection}>
          <Grid container spacing={1}>
            <Grid item xs={4}>
              <ReadOnlyField label="Tipo Orden" value={buyOrderData?.TipoOrden} classes={classes} />
            </Grid>
            <Grid item xs={4}>
              <ReadOnlyField label="Centro Compra" value={buyOrderData?.CentroCompra} classes={classes} />
            </Grid>
            <Grid item xs={4}>
              <ReadOnlyField label="Nro Orden de Servicio" value={buyOrderData?.CodOrden} classes={classes} />
            </Grid>

            <Grid item xs={4}>
              <ReadOnlyField label="Proveedor" value={buyOrderData?.Proveedor} classes={classes} />
            </Grid>
            <Grid item xs={4}>
              <ReadOnlyField label="Proyecto" value={buyOrderData?.Proyecto} classes={classes} />
            </Grid>
            <Grid item xs={4}>
              <ReadOnlyField label="Proyecto Origen" value={buyOrderData?.Proyecto} classes={classes} />
            </Grid>

            <Grid item xs={4}>
              <ReadOnlyField label="Contacto" value={buyOrderData?.ProveedorContacto} classes={classes} />
            </Grid>
            <Grid item xs={4}>
              <ReadOnlyField label="Forma Pago" value={buyOrderData?.FormaDePago} classes={classes} />
            </Grid>
            <Grid item xs={4}>
              <ReadOnlyField label="Tipo Documento" value={buyOrderData?.TipoDocumento} classes={classes} />
            </Grid>
            <Grid item xs={3}>
              <ReadOnlyField label="Moneda" value={buyOrderData?.Moneda} classes={classes} />
            </Grid>


            <Grid item xs={3}>
              <ReadOnlyField label="Fecha" value={buyOrderData?.Fecha?.split("T")[0]} classes={classes} />
            </Grid>
            <Grid item xs={3}>
              <ReadOnlyField
                label="Fecha Vigencia"
                value={buyOrderData?.FechaVigencia?.split("T")[0]}
                classes={classes}
              />
            </Grid>
            <Grid item xs={3}>
              <ReadOnlyField
                label="Fecha Entrega"
                value={buyOrderData?.FechaEntrega?.split("T")[0]}
                classes={classes}
              />
            </Grid>
          </Grid>
        </Box>

        <Tabs value={activeTab} onChange={handleTabChange} className={classes.tabs} variant="fullWidth">
          <Tab label="Detallado" />
          <Tab label="Acumulado" />
          <Tab label="Datos Adicionales" />
          <Tab label="Aprobación" />
          <Tab label="En Almacen" />
          <Tab label="Doc. por Pagar" />
        </Tabs>

        <Box className={classes.tabContent}>{renderTabContent()}</Box>
      </DialogContent>
    </Dialog>
  )
}
